import styled from "styled-components";
import React from "react";

const titleArr = [
  { label: "Giới thiệu", id: "rule-title-1" },
  { label: "Đối tượng tham gia", id: "rule-title-2" },
  { label: "Hạng mục bình chọn", id: "rule-title-3" },
  { label: "Thể lệ bình chọn", id: "rule-title-4" },
  { label: "Bảng quy đổi", id: "rule-title-5" },
  { label: "Quy trình bình chọn", id: "rule-title-6" },
  { label: "Thời gian bình chọn", id: "rule-title-7" },
];

export const LeftSection = () => {
  return (
    <Styles>
      <h2>QUY ĐỊNH VÀ THỂ LỆ</h2>
      <ul>
        {titleArr.map((t, ind) => {
          return (
            <li
              onClick={() => {
                const el = document.getElementById(t.id);
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              {t.label}
            </li>
          );
        })}
      </ul>
    </Styles>
  );
};

const Styles = styled.div`
  position: sticky;
  top: 20px;
  margin: 42px 0 0;
  padding: 0 12px 16px;
  border-radius: 8px;
  background: #212635;
  min-width: 270px;
  height: fit-content;
  h2 {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    padding: 8px 0;
    line-height: 1.5;
    background: -webkit-linear-gradient(right, #ff8a5a, #a15bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-bottom: 1px solid #2c3449;
  }

  li {
    margin: 12px 0 0;
    cursor: pointer;
    position: relative;
    ::after {
      content: url("/images/right-arrow.png");
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media only screen and (max-width: 991px) {
    display: none;
  }
`;
